var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rows)?_c('SortableTable',{attrs:{"rows":_vm.rows,"headers":_vm.RULE_HEADERS,"table-actions":false,"row-actions":false,"key-field":"traceID","default-sort-by":"startTime"},scopedSlots:_vm._u([{key:"col:apiGroup",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('span',[_vm._v(_vm._s(row.apiGroups))])])]}},{key:"col:apiVersion",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('span',[_vm._v(_vm._s(row.apiVersions))])])]}},{key:"col:operations",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('span',[_vm._v(_vm._s(row.operations.join(', ')))])])]}},{key:"col:resources",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('span',[_vm._v(_vm._s(row.resources.join(', ')))])])]}}],null,false,226420521)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }